import React, { useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { MainWrapper } from './Styled'
import PortfolioSlider from './PortfolioSlider'
import ProductsTab from './ProductsTab'
import { portfolioItems } from '../../../projectData/Data'

const Portfolio = () => {
    const { t } = useTranslation();
    
    const uniqueData = [
        "All",
        ...new Set(
            portfolioItems.map((data) => {
                return data.category;
            })
        ),
        
    ];
    const [menuItem, setMenuItem] = useState(portfolioItems);
    const [menuList, setMenuList] = useState(uniqueData);

    const fillter = (category) => {
        if (category === "All") {
            setMenuItem(portfolioItems);
            return;
        }
        const updateMenu = portfolioItems.filter((data) => {
            return data.category === category;
        });
        setMenuItem(updateMenu);

    };

    return (
        <MainWrapper className='section-common mainWrapper'>
            <Container className='container-fluid'>
                <Row className='main-wrap'>
                    
                    <Col md={12} className='sliderMainColC'>
                        <ProductsTab fillter={fillter} menuList={menuList} />
                        {/* <ProductCard menuItem={menuItem} /> */}
                        <PortfolioSlider menuItem={menuItem} />
                    </Col>
                    
                </Row>
            </Container>
        </MainWrapper>
    )
}

export default Portfolio
